export default __webpack_public_path__ + "static/media/search.8b3188d3.svg";